<form [formGroup]="layerForm">
  <section class="sticky top-0 bg-white z-10">
    <p
      class="text-xs text-gray-600 mb-6 leading-relaxed break-words whitespace-normal text-justify max-w-[50ch]"
    >
      Choose a name and pick a list of layers to save as a Scenario for this
      property.
    </p>
    <div class="flex gap-2 items-center">
      <tui-input formControlName="name" class="flex-grow">
        Type Scenario Name
        <input tuiTextfieldLegacy type="email" />
      </tui-input>
      <button
        class="w-10 h-10 rounded-full bg-red-500 text-white flex items-center justify-center hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        (click)="onDelete()"
      >
        <fa-duotone-icon [icon]="['fadr', 'trash']"></fa-duotone-icon>
      </button>
    </div>

    <div
      class="flex items-center justify-start py-2.5 font-bold border-b border-gray-300"
    >
      <label class="flex items-center gap-2">
        <input
          tuiCheckbox
          type="checkbox"
          [indeterminate]="indeterminate()"
          [ngModel]="allSelected()"
          (ngModelChange)="toggleSelectAll($event)"
          [ngModelOptions]="{ standalone: true }"
        />
        Layers
      </label>
    </div>
  </section>

  <tui-scrollbar>
    <div overflowPadding class="max-h-[400px]">
      @for(layer of test(); track layer.layerID) {
      <div
        class="flex items-center justify-start py-2.5 border-b border-gray-200"
      >
        <div class="flex-1 flex items-center gap-2 justify-between">
          <label class="flex items-center gap-2">
            <input
              tuiCheckbox
              type="checkbox"
              [ngModel]="layer.isSelected"
              (ngModelChange)="updateRow(layer.layerID, { isSelected: $event })"
              [ngModelOptions]="{ standalone: true }"
            />
            {{ layer.name }}
          </label>

          <label class="flex items-center gap-2 align-end">
            <input
              tuiSwitch
              type="checkbox"
              [ngModel]="layer.shouldClone"
              (ngModelChange)="onCloneToggle(layer, $event)"
              [ngModelOptions]="{ standalone: true }"
            />
            Clone
          </label>
        </div>
      </div>
      }
    </div>
  </tui-scrollbar>
</form>
<div class="p-2 flex justify-end">
  <button
    class="bg-gray-300 hover:bg-gray-400 text-gray-700 py-2 px-4 rounded mr-2"
    (click)="onNoClick()"
  >
    Cancel
  </button>
  <button
    [disabled]="layerForm.invalid"
    class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded disabled:bg-blue-300 disabled:cursor-not-allowed"
    (click)="onYesClick()"
  >
    Confirm
  </button>
</div>
